'use client';
import { Button } from '../../ui/button.jsx';
export var LoginButton = function (_a) {
    var loginUrl = _a.loginUrl, children = _a.children, _b = _a.isSignup, isSignup = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'outline' : _c;
    var clickHandler = function () {
        var returnTo = window.location.href;
        var loginUrlWithReturnTo = "".concat(loginUrl, "?return_to=").concat(encodeURIComponent(returnTo)).concat(isSignup ? '&login_mode=sign-up' : '');
        window.location.href = loginUrlWithReturnTo;
    };
    return (<Button variant={variant} size="sm" onClick={clickHandler}>
      {children}
    </Button>);
};
